

/* Wrap Iframes in Responsive Emebed */
function iframeEmbed(selector){
  var elem = $(selector);
  elem.wrap( "<div class='video-container'></div>" );
}




// Trigger Mobile Navigation


function navTrigger(trigger,element){
  $(trigger).click(function(e){
    e.preventDefault();
    $('body').toggleClass('nav-open')
  })
}





  function tabs(element){
    $(element).click(function(e){
        e.preventDefault();

        var target = $(this).attr('data-target');
        //console.log('#'+target);
        window.dataLayer.push({
          event: 'selectionMade',
          selectedElement: target
        });
        $(element).removeClass('active');
        $(this).addClass('active');
        $('#'+target).siblings().removeClass('active')
        $('#'+target).addClass('active');
    })
  }

  function selectChange(element){
    $(element).change(function(e){
      e.preventDefault();

        var target = $(this).val();
       // console.log('#'+target);
        window.dataLayer.push({
          event: 'selectionMade',
          selectedElement: target
        });
        $(target).siblings().removeClass('active')
        $(target).addClass('active');

    })
  }


  function clearSearch(elem){
    $(elem).click(function(){
       window.location.href = window.location.href.split('?')[0];
    })
  }


// ajax craft form submissions

function formSubmit(element,thankYou) {

        $('form button').click(function(){
          $(this).closest(element).submit();
        })

        $(element).submit(function(ev) {
        // Prevent the form from actually submitting
        ev.preventDefault();

        // Get the post data
        var data = $(this).serialize();

        // Send it to the server
        $.post('/', data, function(response) {
            if (response.success) {
                $(element).fadeOut();
                $(thankYou).fadeIn();

            } else {
                // response.error will be an object containing any validation errors that occurred, indexed by field name
                // e.g. response.error.fromName => ['From Name is required']
                alert('An error occurred. Please try again.');
            }
        });
    });
}




var trm = {};


function slideSlideToggle(elem,target){
  $(elem).click(function(e){
    e.preventDefault();
    $(target).slideToggle();

  })
}


function triggerSlideOpen(elem,target){
  var navHeight = $('.navigation:visible').outerHeight();
  var offset = navHeight + 20;
  $(elem).click(function(e){
    e.preventDefault();
    $(target).slideDown();
    $('html,body').animate({
       scrollTop: $(target).offset().top - offset
    });

  })
}


trm.timer = [];
trm.timer_current = 0;
trm.timer_interval = 5;

trm.delay = function(callback, ms, timer){
  var timer = typeof timer !== "undefined" ? timer : "default";
  clearTimeout (trm.timer[timer]);
  trm.timer[timer] = setTimeout(callback, ms);
};

var doMarker = function(m,i){


  trm.geocoder.geocode( { 'address': m.address + " " + m.address2 + " " + m.city + " " + m.state + " " + m.zip }, function(results, status) {
    if (status == google.maps.GeocoderStatus.OK) {
      if (status != google.maps.GeocoderStatus.ZERO_RESULTS) {

        if(i == 0)
        {
          trm.results = results;
          trm.map.setCenter(results[0].geometry.location);
          trm.center = results[0].geometry.location;
        }



        var marker = new google.maps.Marker({

          draggable: false,
          position: results[0].geometry.location,
          map: trm.map,
          title: m.address,
          data: m,
          icon: m.marker
        });


        marker.addListener('click', function() {
          infowindow.close(trm.m);
          infowindow.open(trm.map, marker);
        });

        // google.maps.event.addListener(marker, 'click', function() {

        // });

trm.markers.push(marker);
trm.bounds.extend(marker.getPosition());


} else {
  console.log("No results found");
}
} else {
  console.log("Geocode was not successful for the following reason: " + status );
}
});

};

var initMap = function(markers,map){

  trm.markers = [];
  trm.geocoder = new google.maps.Geocoder();
  trm.mapContainer = map;

  var styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];

  var myOptions = {
    zoom: 15,
    navigationControl: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true
  };

  trm.markers = markers;

  trm.map = new google.maps.Map(document.getElementById(trm.mapContainer), myOptions);

  trm.bounds = new google.maps.LatLngBounds();

  trm.rendered = 0;

  markers.forEach(function(m,i){
    trm.timer_current = trm.timer_current + trm.timer_interval;

    trm.delay(function(){
      doMarker(m,i);
    }, trm.timer_current, "marker-" + i);

  });

 if(trm.markers.length > 1){
  trm.delay(function(){

      trm.map.setCenter(trm.bounds.getCenter());
      trm.map.fitBounds(trm.bounds);

  }, 500,"map-bounds");

  } else {

  }



};


/* Init */

function init(){



  $('.mobile-navigation .trigger').click(function(){
    $('.nav-expandable').slideToggle();
  })

  $('.form-check-input.doMore').change(function(){
    if ($(this).is(':checked')){
      $('.streetAddress').fadeIn();
    } else if ($(this).not(':checked').length){
      $('.streetAddress').fadeOut();

    }
  })

    AOS.init({
      easing: 'ease-out-back',
      duration: 1000,
      once: true
    });

    //formSubmit('#contact-form','#thankYou');
   // iframeEmbed('iframe');

    $('.flexslider').flexslider({
      animation: "slide",
      prevText:"",
      nextText:""
    });

    $('.preview').click(function(){
      var url = $(this).attr('data-city');
      $('.modal iframe').attr('src',url);
    })

    clearSearch('#clearSearch');

    $('.dropdown-toggle').dropdown();

    tabs('.equipment-toggle');

    triggerSlideOpen('#triggerQuote','#quoteContent');

    selectChange('.equipment-select');

    //navTrigger('#navTrigger','body');

    $('a[href*=\\#]:not([href=\\#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });


   if ($(window).width() > 961) {

     // headerScroll()

    }

}


$(window).resize(function(){

})


$(document).ready(function(){
  init();
})
